import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SpreadsheetArticle from "../pages/articles/SpreadsheetArticle";
import ShippingArticle from "../pages/articles/ShippingArticle";
import SafetyArticle from "../pages/articles/SafetyArticle";
import ArticlePage from "../pages/articles/ArticlePage";
import AboutPage from "../pages/static/AboutPage";
import ContactPage from "../pages/static/ContactPage";
import DisclaimerPage from "../pages/static/DisclaimerPage";
import PrivacyPage from "../pages/static/PrivacyPage";
import TermsPage from "../pages/static/TermsPage";
import FAQPage from "../pages/static/FAQPage";
import ProductsPage from "../pages/products/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/cssbuy-spreadsheet",
    element: <SpreadsheetArticle />,
  },
  {
    path: "/cssbuy-spreadsheet-guide",
    element: <SpreadsheetArticle />,
  },
  {
    path: "/cssbuy-shipping-guide",
    element: <ShippingArticle />,
  },
  {
    path: "/cssbuy-safety-guide",
    element: <SafetyArticle />,
  },
  {
    path: "/cssbuy-review",
    element: <ArticlePage />,
  },
  {
    path: "/cssbuy-coupon",
    element: <ArticlePage />,
  },
  {
    path: "/cssbuy-warehouse",
    element: <ArticlePage />,
  },
  {
    path: "/cssbuy-qc",
    element: <ArticlePage />,
  },
  {
    path: "/cssbuy-alternatives",
    element: <ArticlePage />,
  },
  {
    path: "/cssbuy-beginner-guide",
    element: <ArticlePage />,
  },
  {
    path: "/cssbuy-shipping-brazil",
    element: <ArticlePage />,
  },
  {
    path: "/cssbuy-shipping-germany",
    element: <ArticlePage />,
  },
  {
    path: "/cssbuy-spreadsheet-shoes",
    element: <ArticlePage />,
  },
  {
    path: "/cssbuy-spreadsheet-hoodies",
    element: <ArticlePage />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/faq",
    element: <FAQPage />,
  },
  {
    path: "/disclaimer",
    element: <DisclaimerPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;